/* ============================================================
   Lil Crescent — Journal JavaScript
   File: assets/lc-journal.js
   Load in layout/theme.liquid just before </body>:
     <script src="{{ 'lc-journal.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    lcFaqDrawers();
    lcTocScrollSync();
    lcMobileToc();
    lcReadingProgress();

  });

  /* ==========================================================
     1. FAQ DRAWERS
     Finds every .lc-faq-item and wires up the .lc-faq-trigger
     button to open/close the .lc-faq-drawer panel.
     Only one drawer open at a time.
  ========================================================== */
  function lcFaqDrawers() {
    var items = document.querySelectorAll('.lc-faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('.lc-faq-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('lc-open');

        // Close every open drawer first
        items.forEach(function (el) {
          if (el.classList.contains('lc-open')) {
            el.classList.remove('lc-open');
            var t = el.querySelector('.lc-faq-trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });

        // If this one was closed, open it
        if (!isOpen) {
          item.classList.add('lc-open');
          trigger.setAttribute('aria-expanded', 'true');

          // Smooth scroll into view if partially off-screen
          var rect = item.getBoundingClientRect();
          if (rect.top < 0) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });
    });
  }

  /* ==========================================================
     2. SCROLL-SYNCED TABLE OF CONTENTS
     - Builds the watch list from the TOC links themselves, so
       it correctly finds ids on .lc-activity divs, headings,
       .lc-faq-section — whatever element carries the id.
     - Updates ALL .lc-toc-list links (sidebar + mobile banner)
       to the .lc-active class as sections scroll into view.
     - Smooth-scrolls on link click with offset for sticky navs.
  ========================================================== */
  function lcTocScrollSync() {
    var tocLinks = document.querySelectorAll('.lc-toc-list a[href^="#"]');
    if (!tocLinks.length) return;

    // Build target list from TOC hrefs — works for any element type
    var targets = [];
    tocLinks.forEach(function (link) {
      var id = link.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      // Avoid duplicates (sidebar + mobile TOC share same ids)
      if (el && targets.indexOf(el) === -1) targets.push(el);
    });

    if (!targets.length) return;

    // ── Smooth scroll on click ──────────────────────────────
    tocLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();

        // Offset for sticky Shopify nav (adjust px if your nav is taller)
        var offset = 80;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // ── IntersectionObserver for active state ───────────────
    var activeId = null;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activeId = entry.target.id;
          setActive(activeId);
        }
      });
    }, {
      // Section is "active" once it crosses 25% from the top
      rootMargin: '-15% 0px -75% 0px',
      threshold: 0
    });

    targets.forEach(function (el) { observer.observe(el); });

    // Fallback: on scroll end, pick the topmost visible heading
    var scrollTimer;
    window.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var best = null;
        var bestTop = Infinity;
        targets.forEach(function (el) {
          var top = el.getBoundingClientRect().top;
          if (top >= 0 && top < bestTop) {
            bestTop = top;
            best = el.id;
          }
        });
        // If we've scrolled past the last heading, keep last active
        if (best && best !== activeId) {
          activeId = best;
          setActive(activeId);
        }
      }, 80);
    }, { passive: true });
  }

  function setActive(id) {
    document.querySelectorAll('.lc-toc-list a').forEach(function (a) {
      var isActive = a.getAttribute('href') === '#' + id;
      a.classList.toggle('lc-active', isActive);
    });
  }

  /* ==========================================================
     3. MOBILE TOC TOGGLE
     The .lc-mobile-toc block (below hero on small screens)
     expands/collapses when its trigger button is clicked.
  ========================================================== */
  function lcMobileToc() {
    var mobileToc = document.querySelector('.lc-mobile-toc');
    if (!mobileToc) return;

    var trigger = mobileToc.querySelector('.lc-mobile-toc-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      mobileToc.classList.toggle('lc-open');
      var expanded = mobileToc.classList.contains('lc-open');
      trigger.setAttribute('aria-expanded', String(expanded));
    });

    // Close mobile TOC when a link inside it is clicked
    mobileToc.querySelectorAll('.lc-toc-list a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileToc.classList.remove('lc-open');
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ==========================================================
     4. READING PROGRESS BAR
     Updates the .lc-toc-progress-bar width based on how far
     the reader has scrolled through the article.
  ========================================================== */
function lcReadingProgress() {
  var bar     = document.querySelector('.lc-toc-progress-bar');
  var pct     = document.querySelector('.lc-toc-progress-pct');
  var article = document.querySelector('.lc-article');
  var journal = document.querySelector('.lc-journal');
  if (!bar || !article) return;

  window.addEventListener('scroll', function () {
    var rect     = article.getBoundingClientRect();
    var total    = article.offsetHeight - window.innerHeight;
    var scrolled = Math.max(0, -rect.top);
    var progress = total > 0 ? Math.min(100, Math.round((scrolled / total) * 100)) : 0;
    var value    = progress + '%';

    // Desktop sidebar bar
    bar.style.width = value;
    if (pct) pct.textContent = value;

    // Mobile top bar via CSS variable
    if (journal) journal.style.setProperty('--lc-mobile-progress', value);
  }, { passive: true });
}

}());